module.exports = __webpack_public_path__ + "img/check.84559c5b.svg";